import { render, staticRenderFns } from "./InputOpcionais.vue?vue&type=template&id=a5584faa&scoped=true"
import script from "./InputOpcionais.vue?vue&type=script&lang=js"
export * from "./InputOpcionais.vue?vue&type=script&lang=js"
import style0 from "./InputOpcionais.vue?vue&type=style&index=0&id=a5584faa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5584faa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5584faa')) {
      api.createRecord('a5584faa', component.options)
    } else {
      api.reload('a5584faa', component.options)
    }
    module.hot.accept("./InputOpcionais.vue?vue&type=template&id=a5584faa&scoped=true", function () {
      api.rerender('a5584faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components/InputOpcionais.vue"
export default component.exports